import { lazy } from 'react';
const DWithdrawal = lazy(() => import('../pages/partner/drivers/Withdrawal'));
const PaymentView = lazy(() => import('../pages/partner/payments/Payment'));
const SingleRide = lazy(() => import('../pages/partner/rides/SingleRide'));
const UserProfile = lazy(() => import('../pages/partner/UserProfile'));
const Mechanic = lazy(() => import('../pages/partner/mechanic/Index'));
const Payment = lazy(() => import('../pages/partner/payments/Index'));
const Earning = lazy(() => import('../pages/partner/earning/Index'));
const Drivers = lazy(() => import('../pages/partner/drivers/Index'));
const Withdrawal = lazy(() => import('../pages/partner/Withdrawal'));
const Dashboard = lazy(() => import('../pages/partner/Dashboard'));
const Trips = lazy(() => import('../pages/partner/drivers/Trips'));
const Edit = lazy(() => import('../pages/partner/drivers/Edit'));
const Ride = lazy(() => import('../pages/partner/rides/Ride'));
const Profile = lazy(() => import('../pages/partner/Profile'));
const Bank = lazy(() => import('../pages/partner/Bank'));

const PartnerRoute = [
    { path: '/partner/', name: 'Bank', component: <Bank /> },
    { path: '/partner/bank-account', name: 'Bank', component: <Bank /> },
    { path: '/partner/profile', name: 'Dashboard', component: <Profile /> },
    { path: '/partner/dashboard', name: 'Dashboard', component: <Dashboard /> },
    { path: '/partner/drivers/:page?', name: 'Drivers', component: <Drivers /> },
    { path: '/partner/driver/withdrawals/:user/:page?', name: 'DWithdrawal', component: <DWithdrawal /> },
    { path: '/partner/mechanic/withdrawals/:user/:page?', name: 'DWithdrawal', component: <DWithdrawal /> },
    { path: '/partner/driver/edit/:id', name: 'Edi', component: <Edit /> },
    { path: '/partner/earnings/:type/:page?', name: 'Earning', component: <Earning /> },
    { path: '/partner/driver/trips/:page?', name: 'Trips', component: <Trips /> },
    { path: '/partner/withdrawal', name: 'Withdrawal', component: <Withdrawal /> },
    { path: '/partner/bookings/:type?/:page?', name: 'Ride', component: <Ride /> },
    { path: '/partner/driver/payment/:page?', name: 'Payment', component: <Payment /> },
    { path: '/partner/driver/payment/:type/:id', name: 'Payment', component: <PaymentView /> },
    { path: '/partner/ride/:type/:id', name: 'SingleRide', component: <SingleRide /> },
    { path: '/partner/:type/profile/:id', name: 'User', component: <UserProfile /> },
    { path: '/partner/mechanics/:page?', name: 'Mechanic', component: <Mechanic /> },
];
export default PartnerRoute;